import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import React from 'react';
import classNames from 'classnames';

var Bar = function Bar() {
  return jsx("div", {});
};
var Bars = function Bars(_ref) {
  var cssClass = _ref.cssClass;
  return jsxs("div", {
    className: cssClass,
    children: [jsx(Bar, {}), jsx(Bar, {}), jsx(Bar, {}), jsx(Bar, {})]
  });
};
var renderTips = function renderTips(text, title, darkMode, width) {
  if (!text && !title) {
    return null;
  }
  var textColorClass = darkMode ? 'loader-text--white' : 'loader-text--black';
  var textWrapperStyle = {
    width: width * 3 + "px",
    left: "calc(50% - " + width * 3 / 2 + "px)"
  };
  return jsxs("div", {
    className: "cogs-v10 cogs-info--wrapper",
    children: [jsx("p", {
      className: "cogs-info--title " + textColorClass,
      children: title
    }), jsx("div", {
      className: "cogs-v10 cogs-info--text-wrapper",
      style: textWrapperStyle,
      children: jsx("div", {
        className: "cogs-info--text " + textColorClass,
        children: text
      })
    })]
  });
};
/**
 * Basic loading component
 */
var Loader = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var _a$width = _a.width,
    width = _a$width === undefined ? 200 : _a$width,
    _a$animationDuration = _a.animationDuration,
    animationDuration = _a$animationDuration === undefined ? 2 : _a$animationDuration,
    _a$darkMode = _a.darkMode,
    darkMode = _a$darkMode === undefined ? true : _a$darkMode,
    _a$infoTitle = _a.infoTitle,
    infoTitle = _a$infoTitle === undefined ? '' : _a$infoTitle,
    _a$infoText = _a.infoText,
    infoText = _a$infoText === undefined ? '' : _a$infoText,
    otherProps = __rest(_a, ["width", "animationDuration", "darkMode", "infoTitle", "infoText"]);
  var style = {
    '--animation-duration': animationDuration + "s",
    '--width': width + "px",
    '--dark-mode': !darkMode && '4px 4px 20px #d9d9d9, -4px -4px 20px #ffffff'
  };
  return jsxs("div", Object.assign({
    ref: ref,
    id: "red",
    className: classNames('cogs-v10', 'cogs-loader', {
      'has-no-text': !infoText && !infoTitle
    }),
    style: style
  }, otherProps, {
    children: [jsx(Bars, {
      cssClass: "upper"
    }), jsx(Bars, {
      cssClass: "lower"
    }), renderTips(infoText, infoTitle, darkMode, width)]
  }));
});

export { Loader };
